const old_people_finland  = `In Finland, older people are usually treated with respect and care. 
People understand that they have a lot of wisdom and experience, which is important. 
Many families and communities take care of their older members and make sure they are safe and happy.
There are places called care homes where older people can live if they need help with everyday things. 
These places have nurses and caregivers who look after them and make sure they have everything they need. 
It's important to make sure older people feel comfortable and valued.
Some older people might live alone and need help from others. 
There are services and organizations that help them with things like shopping and going to the doctor. 
It's important to make sure they can live their lives with dignity and independence.
Overall, it's nice to see that older people in Finland are respected and taken care of. 
They are an important part of the community, and it's important to make sure they feel loved and appreciated.`;

export default old_people_finland;